module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"prismic-content-no-result-error":"Aucun contenu n\u0027a été trouvé pour ces critères."},"en":{"prismic-content-no-result-error":"No content has been found for these criteria."}}')
  delete Component.options._Ctor
}
